import { render } from "./StationDetail.vue?vue&type=template&id=7ed03640&scoped=true"
import script from "./StationDetail.vue?vue&type=script&lang=js"
export * from "./StationDetail.vue?vue&type=script&lang=js"

import "./StationDetail.vue?vue&type=style&index=0&id=7ed03640&scoped=true&lang=css"

import exportComponent from "E:\\work\\苏州卓盛\\捷博独立发货\\jb-dji-wms-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ed03640"]])

export default __exports__